import type { JSX, ParentComponent } from "solid-js";

type SettingSectionProps = {
  title: string;
  ariaIdPrefix: string;
  description: string | JSX.Element;
  col?: boolean;
  id_name?: string;
};

const SettingSection: ParentComponent<SettingSectionProps> = (props) => (
  <section
    aria-labelledby={`${props.ariaIdPrefix}-title`}
    aria-describedby={`${props.ariaIdPrefix}-description`}
    class="grid grid-cols-12 gap-6"
  >
    <div class="col-span-5">
      <h4 id={`${props.ariaIdPrefix}-title`} class="text-header-lg text-primary">
        {props.title}
      </h4>
      <p id={`${props.ariaIdPrefix}-description`} class="text-medium-regular text-secondary">
        {props.description}
      </p>
    </div>
    <div class="col-span-7 flex gap-6" classList={{ "flex-col": props.col }}>
      {props.children}
    </div>
  </section>
);

export default SettingSection;
